import { FC } from 'react';
import { useFieldState, useFormApi } from 'informed';
import { t } from 'i18next';
import moment from 'moment';
import { DateField } from '@ui-modules/informed';
import { getFullDate } from '../../../../utils';
import '../../BookingPanel.styles.scss';

const TIME_INTERVAL = 15;

interface DropOffTimeFieldProps {
  disabled?: boolean;
  leg: number;
  value: string;
  onChange?: (value: Date | string) => void;
}

const DropOffTimeField: FC<DropOffTimeFieldProps> = ({ disabled, leg, value, onChange }) => {
  const formApi = useFormApi();
  const { value: dropoffDate } = useFieldState(`${leg}.dropoffDate`);
  const { value: pickupDate } = useFieldState(`${leg}.pickupDate`);
  const { value: pickupTime } = useFieldState(`${leg}.pickupTime`);

  return (
    <div className="field" data-testid={`drive-dropoff-time-${leg}`}>
      <DateField
        className="input"
        dateFormat="HH:mm"
        defaultValue={value ? moment(value, 'HH:mm').toDate() : undefined}
        disabled={disabled}
        label={t('bookingDetails.estimatedDropoffTime')}
        name={`${leg}.dropoffTime`}
        placeholder={t('bookingDetails.chooseTime')}
        showTimeSelect
        showTimeSelectOnly
        timeCaption={undefined}
        timeFormat="HH:mm"
        timeIntervals={TIME_INTERVAL}
        onChange={(val: Date | string) => {
          onChange?.(val);

          if (moment(val).isSameOrBefore(pickupTime as Date)) {
            const dropoffFullDate = getFullDate(dropoffDate as Date, moment(val).toDate());
            const pickupFullDate = getFullDate(
              pickupDate as Date,
              moment(val).subtract(TIME_INTERVAL, 'minutes').toDate(),
            );

            if (moment(pickupFullDate).isAfter(dropoffFullDate)) {
              formApi.setValue(
                `${leg}.pickupDate`,
                moment(pickupDate as Date)
                  .subtract(1, 'day')
                  .toDate(),
              );
            }

            formApi.setValue(
              `${leg}.pickupTime`,
              moment(val).subtract(TIME_INTERVAL, 'minutes').toDate(),
            );
          }
        }}
      />
    </div>
  );
};

export default DropOffTimeField;
